import { store } from '@/store';
import { Size } from '@react-three/fiber';
import { IDomIdSelectors, IScreenRelativeDevice, IScreenRelativeDeviceLabels } from '../../../../typings';
import { IScreenRelativeScaleType } from '../r3f-components/component-data-structure/types/screenRelative';


interface IDeviceheightData {
    height: number | undefined;
    browserUI: number | undefined;
    visibleHeight: number | undefined;
}

export const dummyDeviceToViewportHeightDataDict: Record<IScreenRelativeDeviceLabels, IDeviceheightData> = {
    ['iPhone 15']: {
		height: 852,
		browserUI: 80,
		visibleHeight: 772,
	},
    ['Galaxy S7']: {
		height: 640,
		browserUI: 112,
		visibleHeight: 528,
	},
	['Pixel 8a']: {
		height: 915,
		browserUI: 112,
		visibleHeight: 803,
	},
	['iPad 11 Pro']: {
		height: 1194,
		browserUI: 80,
		visibleHeight: 1114,
	},
    ['Horizontal']: {
        height: 1194 / 1.5,
        browserUI: 80,
        visibleHeight: 1114 / 1.5,
    },
    ['Custom']: {
        height: undefined,
        browserUI: undefined,
        visibleHeight: undefined,
    }
};

export const calculateDummyDeviceNormalizationFactor = (args: {dummyDevice: IScreenRelativeDevice, screenRelativeContentScaleType: IScreenRelativeScaleType | undefined, dummyDeviceViewportData: IDeviceheightData, size: Size}) => {
    const { dummyDevice, screenRelativeContentScaleType, dummyDeviceViewportData, size } = args;
    
    let dummyNormalizationFactor = 1;

    if (screenRelativeContentScaleType === 'absolute') {
        if (dummyDevice.label !== IScreenRelativeDeviceLabels.CUSTOM) {
            dummyNormalizationFactor = size.height / (dummyDeviceViewportData.visibleHeight ?? size.height);
        } else dummyNormalizationFactor = size.height / dummyDevice.height;
    }
    return dummyNormalizationFactor;
}



export const getDummyDeviceNormalizationFactor = () => {
    const containerDiv = document.getElementById(IDomIdSelectors.screenRelativeCanvas) as HTMLDivElement | undefined;
    const canvas = containerDiv?.querySelector('canvas') as HTMLCanvasElement | undefined;
    if (!canvas) return 1;

    const size = { width: canvas.clientWidth, height: canvas.clientHeight } as Size;
    const screenRelativeContentScaleType = store.getState().contentReducer.contentDoc.screenRelativeScaleType;
    const dummyDevice = store.getState().userReducer.screenRelativeDevice;
    const dummyDeviceViewportData = dummyDeviceToViewportHeightDataDict[dummyDevice.label]; 

    return calculateDummyDeviceNormalizationFactor({dummyDevice, screenRelativeContentScaleType, dummyDeviceViewportData, size});
}
